<script>
import { Doughnut, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;


export default {
    extends: Doughnut,
    mixins: [reactiveProp],
    data() {
        return {
            options: {
                cutoutPercentage: 70,   
                rotation: 0.5 * Math.PI,
                responsive: true,
                maintainAspectRatio: true,
                aspectRatio: 1,
                legend: {
                    display: false
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltipItem, data) {         
                            return  data.labels[tooltipItem.index] +': '+data.datasets[0].data[tooltipItem.index].toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + '';
                        }
                    }
                },
                title: {
                    display: true,
                    text: "Balansräkning"
                }
            }
        }
    },

    mounted() {
        this.renderChart(this.chartData, this.options)
    },

    watch: {
        chartData: {
            handler() {
                this.renderChart(this.chartData, this.options)
            },
            deep: true
        }
    }

}

</script>
